import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AboutusComponent } from './components/aboutus/aboutus.component';
import { ContactusComponent } from './components/contactus/contactus.component';
import { HomecarouselComponent } from './components/homecarousel/homecarousel.component';
import { ProductComponent } from './components/product/product.component';

const routes: Routes = [{ path: 'about', component: AboutusComponent },         // default route
  { path: 'contact', component: ContactusComponent }, { path: 'home', component: HomecarouselComponent },
   { path: 'products', component: ProductComponent }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
